import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../components/ui/button";
import Common from "../../helper/common";
import AdvanceTable from "../../components/advanceTable";
import { AppSearchSelect } from "../../components/appComponents";
import AddClubAmenity from "./components/addClubAmenity";

const ClubAmenities = () => {
  const [data, setData] = useState({});
  const [amenityId, setAmenityId] = useState(null);
  const [amenityList, setAmenityList] = useState([]);
  const [open, setOpen] = useState(false);
  const [refId, setRefId] = useState(null);

  useEffect(() => {
    getData(1);
    getAmenities();
  }, []);

  useEffect(() => {
    if (!open && refId) {
      setRefId();
    }
  }, [open]);

  useEffect(() => {
    getData(1);
  }, [amenityId]);

  const resetFilters = () => {
    setAmenityId(null);
  };

  const getData = async (
    pageNumber,
    searchTerm = "",
    recordsToDisplay = null
  ) => {
    const response = await Common.ApiService.getInstance().request(
      "GetClubAmenities",
      {
        pageNumber: pageNumber,
        q: searchTerm,
        isactive: true,
        recordsToDisplay,
        amenityId: amenityId,
      },
      "Post"
    );
    if (response?.data) {
      let obj = {
        ...response.data[0],
        data: response.data[0].data.map((item) => ({
          ...item,
          createdon: Common.Utility.ConvertTime(item.createdon),
          updatedon: Common.Utility.ConvertTime(item.updatedon),
        })),
      };

      setData(obj);
    }
  };

  const getAmenities = async () => {
    return new Promise(async (res) => {
      const response = await Common.ApiService.getInstance().request(
        "GetMasterAmenities",
        {
          isactive: true,
        }
      );
      const data = [{ id: null, name: "All" }, ...(response?.data ?? [])];
      setAmenityList(data);
      // Set default to "All"
      setAmenityId(null);
    });
  };

  const columns = [
    { title: "Id", type: "number", isVisible: false, key: "id" },
    {
      title: "Name",
      type: "text",
      isVisible: true,
      key: "name",
    },
    {
      title: "Facility Type",
      type: "text",
      isVisible: true,
      key: "amenityName",
    },
    {
      title: "Default Charges",
      type: "text",
      isVisible: true,
      key: "defaultcharges",
    },
    {
      title: "Status",
      type: "text",
      isVisible: true,
      key: "isactive",
      render: (val) => (val ? "Active" : "Inactive"),
    },
    // { title: "Created On", type: "text", isVisible: true, key: "createdon" },
    // { title: "Updated On", type: "text", isVisible: true, key: "updatedon" },
  ];

  const actions = [
    {
      type: "edit",
      onClick: (val) => _onEdit(val.id),
    },
    {
      type: "delete",
      onClick: (val) => _handleDelete(val.id),
    },
  ];

  const _onEdit = async (id) => {
    setOpen(true);
    setRefId(id);
  };

  const _handleDelete = async (id) => {
    const isConfirmed = await Common.SweetAlert.confirmation(
      "Are you sure you want to delete this Facility?",
      "Delete Facility"
    );
    if (isConfirmed) {
      let resp = await Common.ApiService.getInstance().request(
        `DeleteClubAmenity?id=${id}`,
        {},
        "Delete"
      );
      Common.SweetAlert.alert(resp.message, "success");
      setTimeout(() => {
        getData(1);
      }, 500);
    }
  };

  const _addUpdateTrigger = () => (
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>
  );

  return (
    <>
      <div className="md:grid md:grid-cols-6 gap-3 ">
        <AppSearchSelect
          value={amenityId}
          onChange={setAmenityId}
          placeholder={"All"}
          label={"Facility Type"}
          data={amenityList}
          className={"mb-3 col-span-1"}
        />

        <Button className="lg:mt-6 h-8 mb-5" onClick={resetFilters}>
          Reset Filters
        </Button>
      </div>

      {data?.data && (
        <AdvanceTable
          title={"Facilities"}
          columns={columns.filter((item) => item.isVisible)}
          data={data}
          getData={getData}
          showPagination
          showAddButton
          actionButtons={actions}
          addButton={() => (
            <AddClubAmenity
              id={refId}
              onClose={() => getData()}
              open={open}
              setOpen={setOpen}
            />
          )}
          updateTrigger={_addUpdateTrigger}
        />
      )}
    </>
  );
};

export default ClubAmenities;
